<template>
  <div class="topic-deeplink-container">
    <template v-if="initialized">
      <topic
        :subtopic="currentSubtopic"
        :topic="currentTopic"
        @accordion-toggled="handleAccordionToggle"
        @nested-subtopic-selected="handleNestedSubtopicSelected"
      />
      <modal
        v-for="(topic, index) in modals"
        :key="topic.id"
        :subtopic="currentSubtopic"
        :topic="topic"
        :modal-idx="index"
        :num-of-modals="modals.length"
        @accordion-toggled="handleAccordionToggle"
        @topic-modal-back-clicked="handleModalTopicBack"
        @nested-subtopic-selected="handleNestedSubtopicSelected"
      />
    </template>
  </div>
</template>

<script>
import Modal from '@components/topics/modal';
import Topic from '@components/topics/topic';
import GlobalMixin from '@/mixins/global';

export default {
  components: { Modal, Topic },
  mixins: [GlobalMixin ],
  data() {
    return {
      initialized: false, // using this to wait to render ensures current topic among other things are defined
      modals: [],
    };
  },
  computed: {
    currentTopic() {
      return this.$store.getters['topics/topics'][this.$route.params.topicId];
    },
    currentSubtopic() {
      return this.$store.getters['topics/topics'][this.$route.params.subtopicId];
    },
    title() {
      return this.currentTopic?.title;
    },
  },
  watch: {
    'currentSubtopic': {
      immediate: true,
      handler: function(newSubtopic, previousSubtopic) {
        if (newSubtopic) {
          let pathIds = newSubtopic.path.split('.').map(id => Number(id));
          let modalIds = pathIds.filter((id, index) => index % 2 === 0 && index !== 0);
          let modalTopics = modalIds.map(id => this.$store.getters['topics/topics'][id]);
          this.modals = modalTopics.reverse();
        } else {
          this.collapseEverything();
        }
      },
    },
  },
  created() {
    this.$store.dispatch('topics/load', { ids: [this.$route.params.topicId]}).then(() => {
      this.initialized = true;
    });
  },
  methods: {
    collapseEverything() {
      this.modals = [];
    },
    handleAccordionToggle([closed, subtopic, topic]) {
      let params = {
        categoryId: this.$route.params.categoryId,
        topicId: this.currentTopic.id,
      };

      if (closed) {
        if (!topic.path.includes('.')) {
          params.subtopicId = topic.id;
        }
      } else {
        params.subtopicId = subtopic.id;
      }

      this.$router.push({name: this.$route.name, params: params, query: this.$route.query});
    },
    handleModalTopicBack(subtopic) {
      let route = {
        name: this.$route.name,
        params: { ...this.$route.params },
        query: this.$route.query,
      };

      if (subtopic) {
        route.params.subtopicId = subtopic.id;
      } else {
        route.params.subtopicId = undefined;
      }

      this.$router.push(route);
    },
    handleNestedSubtopicSelected(subtopic) {
      let route = {
        name: this.$route.name,
        params: { topicId: this.$route.params.topicId, subtopicId: subtopic.id },
        query: this.$route.query,
      };

      this.$router.push(route);
    },
  },
};

</script>

<style lang="scss" scoped>
.topic-deeplink-container {
  padding-left: 0 !important;
  padding-right: 0 !important;
  .topic-component-container {
    padding-bottom: rem-calc(48);
  }
}
</style>
